import { type BillingInfo, SubscriptionSeat, type LensPlatformClient } from "lens-platform-sdk";
import { useGetLicense } from "src/hooks/useGetLicense";

export interface SubscriptionSeatWithBillingPeriod extends SubscriptionSeat {
  billingPeriod: string | null;
}

// The personal plan name is configured in Keycloak, and is not a plan in Recurly
// https://k8slens.recurly.com/plans
export const LensDesktopPersonalLicenseType = {
  personal: "personal",
} as const;

// "Lens Desktop Pro" are plan names in Recurly, plus LensDesktopPersonalLicenseType
// https://k8slens.recurly.com/plans
export const LensDesktopLicenseType = {
  ...LensDesktopPersonalLicenseType,
  proTrial: "Lens Desktop Pro Trial",
  pro: "Lens Desktop Pro",
  proProd: "Pro",
} as const;

export const LicenseType = {
  ...LensDesktopLicenseType,
  appIQPro: "Lens App IQ Pro",
} as const;

type DecodedAccessToken = Exclude<Awaited<ReturnType<LensPlatformClient["getDecodedAccessToken"]>>, undefined>;

export interface LicensedToken extends DecodedAccessToken {
  license_type: (typeof LicenseType)[keyof typeof LicenseType];
  license_exp: number;
  license_iat: number;
  license_trial: boolean;
  license_features?: string[];
}

export type License = {
  type: LicensedToken["license_type"];
  trial: boolean;
  features: LicensedToken["license_features"];
  expiration: Date;
  issuedAt: Date;
};

interface LicenseContainerProps {
  license: ReturnType<typeof useGetLicense>;
  onLicenseChange?: () => void;
  onCancelSubscription?: (license: License) => void;
  billingInfoUrl?: string;
  accountUrl?: string;
  billingInfo?: BillingInfo | null;
  subscriptionSeats: SubscriptionSeat[];
  currentSubscriptionSeatWithBillingPeriod?: SubscriptionSeatWithBillingPeriod;
}

export type LicenseContainer = React.FunctionComponent<LicenseContainerProps>;
